(function() {
  'use strict';
  angular.module('app')
    .directive('sidebar', function($templateCache) {
      return {
        restrict: 'E',
        template: $templateCache.get('modules/core/sidebar/sidebar.html'),
        replace: 'true',
        controller: 'SidebarCtrl',
        bindToController: true
      };
    });
}());
